document.addEventListener("DOMContentLoaded", () => {
  function restoreDefaultVariantCard(card) {
    if (!card) return;
    card.querySelectorAll("[data-variant-color]").forEach((el) => {
      el.style.visibility = "hidden";
    });
    const primaryImage = card.querySelector(".product-card__featured-image");
    if (primaryImage) primaryImage.style.visibility = "visible";
    card
      .querySelectorAll(".product-card__secondary-image:not([data-variant-color])")
      .forEach((el) => {
        el.style.visibility = "visible";
      });
  }

  if (window.innerWidth < 768) {
    const whatDevice2 = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const whatEventUse2 = whatDevice2 ? "touchend" : "click";

    document.querySelectorAll(".default-swatch").forEach((swatch) => {
      swatch.addEventListener(whatEventUse2, (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (!card) return;
        card.querySelectorAll("[data-variant-color]").forEach((el) => {
          el.style.visibility = "hidden";
        });
        const secondaryImage = card.querySelector(
          `[data-variant-color='${event.currentTarget.title}']`
        );
        if (!secondaryImage) return;
        secondaryImage.style.visibility = "visible";
        const primaryImage = card.querySelector(".product-card__featured-image");
        if (primaryImage) primaryImage.style.visibility = "hidden";
        const primarySecondaryImage = card.querySelector(
          ".product-card__secondary-image:not([data-variant-color])"
        );
        if (primarySecondaryImage) primarySecondaryImage.style.visibility = "hidden";
      });
    });

    document.querySelectorAll(".primary-default-swatch").forEach((primary) => {
      primary.addEventListener(whatEventUse2, (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (!card) return;
        card.querySelectorAll("[data-variant-color]").forEach((el) => {
          el.style.visibility = "hidden";
        });
        const primaryImage = card.querySelector(".product-card__featured-image");
        if (primaryImage) primaryImage.style.visibility = "visible";
        const primarySecondaryImage = card.querySelector(
          ".product-card__secondary-image:not([data-variant-color])"
        );
        if (primarySecondaryImage) primarySecondaryImage.style.visibility = "visible";
      });
    });
  } else {
    document.querySelectorAll(".default-swatch").forEach((swatch) => {
      swatch.addEventListener("click", (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (card) card.dataset.clickedColor = event.currentTarget.title;
      });
      swatch.addEventListener("mouseover", (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (!card) return;
        card.querySelectorAll("[data-variant-color]").forEach((el) => {
          el.style.visibility = "hidden";
        });
        const secondaryImage = document.querySelector(
          `[data-product-card='${pid}'] [data-variant-color='${event.currentTarget.title}']`
        );
        if (!secondaryImage) return;
        secondaryImage.style.visibility = "visible";
        secondaryImage.classList.add(
          "sm:transition-transform",
          "sm:duration-300",
          "sm:group-hover:scale-[103%]"
        );
        const primaryImage = card.querySelector(".product-card__featured-image");
        if (primaryImage) primaryImage.style.visibility = "hidden";
        const primarySecondaryImage = card.querySelector(
          ".product-card__secondary-image:not([data-variant-color])"
        );
        if (primarySecondaryImage) primarySecondaryImage.style.visibility = "hidden";
      });
    });

    document.querySelectorAll(".primary-default-swatch").forEach((primary) => {
      primary.addEventListener("click", (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (card) delete card.dataset.clickedColor;
      });
      primary.addEventListener("mouseover", (event) => {
        const pid = event.currentTarget.dataset.productId;
        const card = document.querySelector(`[data-product-card='${pid}']`);
        if (!card) return;
        card.querySelectorAll("[data-variant-color]").forEach((secondImg) => {
          secondImg.style.visibility = "hidden";
        });
        const primaryImage = card.querySelector(".product-card__featured-image");
        const primarySecondaryImage = card.querySelector(".product-card__secondary-image");
        if (primaryImage) primaryImage.style.visibility = "visible";
        if (primarySecondaryImage) primarySecondaryImage.style.visibility = "visible";
      });
    });

    document.querySelectorAll("fieldset.swatches").forEach((fieldset) => {
      const card = fieldset.closest("[data-product-card]");
      if (!card || !card.querySelector(".default-swatch")) return;
      fieldset.addEventListener("mouseleave", () => {
        if (card.dataset.clickedColor) {
          card.querySelectorAll("[data-variant-color]").forEach((el) => {
            el.style.visibility = "hidden";
          });
          const clicked = card.querySelector(`[data-variant-color='${card.dataset.clickedColor}']`);
          if (clicked) {
            clicked.style.visibility = "visible";
            const pi = card.querySelector(".product-card__featured-image");
            if (pi) pi.style.visibility = "hidden";
            const ps = card.querySelector(".product-card__secondary-image:not([data-variant-color])");
            if (ps) ps.style.visibility = "hidden";
          } else {
            restoreDefaultVariantCard(card);
          }
        } else {
          restoreDefaultVariantCard(card);
        }
      });
    });

    // Featured-image hover preview (variant swatches only; radio change stays in swatch-radios.js)
    document.querySelectorAll("product-card swatch-radios").forEach((sr) => {
      const card = sr.closest("product-card");
      if (!card || card.querySelector(".sibling-swatch")) return;

      const fieldset = sr.querySelector("fieldset");
      const img = card.querySelector(".product-card__featured-image");
      if (!fieldset || !img) return;

      const fallback = {
        src: img.getAttribute("src") || img.src,
        srcset: img.getAttribute("srcset") || "",
        sizes: img.getAttribute("sizes") || "",
      };

      const setVariantUrl = (url) => {
        img.src = url;
        img.srcset = "";
        img.sizes = "";
      };

      const restorePrimaryImage = () => {
        img.src = fallback.src;
        if (fallback.srcset) img.setAttribute("srcset", fallback.srcset);
        else img.removeAttribute("srcset");
        if (fallback.sizes) img.setAttribute("sizes", fallback.sizes);
        else img.removeAttribute("sizes");
      };

      fieldset.addEventListener("mouseover", (e) => {
        const label = e.target.closest("label.swatch-item__label");
        if (!label || !fieldset.contains(label)) return;
        const input = label.control;
        if (!input?.dataset?.variantImage) return;
        setVariantUrl(input.dataset.variantImage);
        img.style.opacity = "1";
        const secondary = card.querySelector(".product-card__secondary-image:not([data-variant-color])");
        if (secondary) secondary.style.visibility = "hidden";
      });

      fieldset.addEventListener("mouseleave", () => {
        if (card.dataset.clickedColor) {
          const checked = sr.querySelector('input[type="radio"]:checked');
          const url = checked?.dataset?.variantImage;
          if (url) {
            setVariantUrl(url);
          } else {
            restorePrimaryImage();
          }
        } else {
          restorePrimaryImage();
        }
        img.style.opacity = "";
      });
    });
  }
});
